module.exports = __webpack_public_path__ + "pc-top-assets/img/logo-white.82ac9285.png";